import React from 'react';
import mergeClasses from '../../../utils/shallowMerge';
import { Heading } from '../../typography/heading/Heading';
import { Text } from '../../typography/text/Text';
import Title from '../../typography/title';
import defaultClasses from '@srcDS/components/molecules/categoryTitleAndDescription/CategoryTitleAndDescription.module.scss';

interface CategoryTitleAndDescriptionProps {
  title?: string;
  subtitle?: string;
  customClasses?: string | null;
  searchPhrase?: string;
  theme?: string;
}

const CategoryTitleAndDescription: React.FC<CategoryTitleAndDescriptionProps> = ({
  title = '',
  subtitle = '',
  customClasses = null,
  searchPhrase,
}) => {
  const styles = mergeClasses(defaultClasses, customClasses);

  const containsHTML = (str: string) => /<[a-z][\s\S]*>/i.test(str);

  const searchTitle = () => {
    const searchPhraseVal = searchPhrase?.replaceAll('%20', ' ');
    return `${title} for ‘${searchPhraseVal}’`;
  };

  const titleText = searchPhrase ? searchTitle() : title;

  return (
    <Title className={styles.root}>
      {title && (
        <Heading as="h1" placement="plp" align="center" textTransform="uppercase" weight="light">
          {containsHTML(titleText) ? <span dangerouslySetInnerHTML={{ __html: titleText }} /> : titleText}
        </Heading>
      )}
      {subtitle && (
        <Text className={styles.subtitle} align="center" as="p" size="xs">
          {containsHTML(subtitle) ? <span dangerouslySetInnerHTML={{ __html: subtitle }} /> : subtitle}
        </Text>
      )}
    </Title>
  );
};

export default CategoryTitleAndDescription;
